export const hasActiveSession = async (): Promise<boolean> => {
  try {
    const response = await fetch('/api/auth/session', { cache: 'no-store' });
    if (!response.ok) {
      return false;
    }
    const data: { user?: unknown } | null = await response.json();
    return Boolean(data?.user);
  } catch {
    return false;
  }
};
